export const FORM_FIELD_MIN_WIDTH = '320px';
